import script from "./LtContent.vue?vue&type=script&setup=true&lang=js"
export * from "./LtContent.vue?vue&type=script&setup=true&lang=js"

import "./LtContent.vue?vue&type=style&index=0&id=5a62035a&lang=scss&scoped=true"

import exportComponent from "/builds/frontend/linjie/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a62035a"]])

export default __exports__